<template>
  <div>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="tipo_instituicao.nome"
        placeholder="Nome"
        :state="validateState('nome')"
      />
      <b-form-text v-if="!!tipo_instituicao.id">
        Para editar os dados de tradução do termo, clique em
        <b-button
          variant="link"
          size="sm"
          class="px-0"
          target="_blank"
          :to="{
            name: 'termos_filtros_edit',
            params: { id: tipo_instituicao.id, tipo: 'natureza' },
          }"
        >
          editar tradução
          <font-awesome-icon icon="arrow-up-right-from-square" size="sm" />
        </b-button>
      </b-form-text>
      <b-form-invalid-feedback>
        Nome é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Descrição:">
      <b-form-textarea
        v-model="tipo_instituicao.descricao"
        placeholder="Descrição"
      ></b-form-textarea>
    </b-form-group>
    <b-form-group label="Plano padrão:">
      <select-plano v-model="tipo_instituicao.plano_padrao_id" />
    </b-form-group>
    <b-form-group label="Categoria relacionada:">
      <select-categoria v-model="tipo_instituicao.categoria_instituicao_id" />
    </b-form-group>
  </div>
</template>

<script>
import SelectCategoria from "@/modules/tipos_instituicoes/Components/SelectCategoria.vue";
import SelectPlano from "@/modules/planos/Components/SelectPlano.vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  components: {
    SelectPlano,
    SelectCategoria,
  },
  data: () => ({}),
  validations: {
    tipo_instituicao: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("tipos_instituicoes", ["tipo_instituicao"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.tipo_instituicao[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.tipo_instituicao.$touch();
      return !this.$v.tipo_instituicao.$anyError;
    },
  },
  created() {},
};
</script>
